import { HTMLAttributes } from 'react'

import Typography from '@/components/base/typography'
import { useLocaleStore } from '@/store/locale'
import { LANGUAGES } from '@/constants'

import { cn } from '@/lib/utils'

type LanguageListProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    onClose: () => void
    className: string
  }>

const LanguageList: React.FC<LanguageListProps> = ({ className, ...props }) => {
  const [currentLocale, currentTranslations] = useLocaleStore((state) => [
    state.currentLocale,
    state.currentTranslations
  ])

  // console.log('currentTranslations ---->', currentLocale)

  return (
    <div className={cn('flex items-center gap-spacing-2xs', className)} {...props}>
      {LANGUAGES.map((lang: string, index: number) => (
        <div key={index.toString()}>
          <a
            href={
              currentTranslations?.find((t: { locale: string }) => t.locale.includes(lang))?.href ||
              `/${lang}`
            }
            className={cn('inline-flex', {
              '!pointer-events-none': currentLocale === lang
            })}
          >
            <Typography
              variant="small"
              className={cn('uppercase dark:text-text-heading-invert-light', {
                'font-semibold underline': currentLocale === lang
              })}
            >
              {lang}
            </Typography>
          </a>
        </div>
      ))}
    </div>
  )
}

export default LanguageList
